import React, { useState } from 'react';
import axios from 'axios';
import BoardList from '../../components/Board/BoardList';
import BoardWrite from '../../components/Board/BoardWrite';
import BoardDetail from '../../components/Board/BoardDetail';
import Breadcrumb from '../../components/common/Breadcrumb';

const SampleRequest = () => {
  const [mode, setMode] = useState('list');
  const [selectedPost, setSelectedPost] = useState(null);

  const handleSubmit = async (form) => {
    try {
      const productName = form.products.join(', ');
      const title = `${form.products[0] || '제품'} 샘플 요청`;
      const content = form.address || '';

      await axios.post('/api/user/requests/write', {
        type: 'sample',
        title,
        content,
        use_purpose: form.use_purpose,
        product_id: null,
        product_name: productName,
        company_name: form.company_name,
        author_name: form.author_name,
        author_phone: form.author_phone,
        author_email: form.author_email || null,
        quantity: null,
        password: form.password,
        is_private: 1,
      });

      alert('샘플 요청이 등록되었습니다.');
      setMode('list');
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || '등록에 실패했습니다.');
    }
  };

  return (
    <div className="sub-page">
      <section className="sub-visual sample">
        <div className="container">
          <span className="sub-title">SAMPLE REQUEST</span>
          <h1>샘플요청</h1>
          <p>제품의 품질을 직접 확인해보실 수 있도록 샘플을 발송해드립니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <div className="container content-wrap">
        {mode === 'list' && (
          <BoardList
            type="sample"
            title="샘플요청 리스트"
            onWrite={() => setMode('write')}
            onDetail={(item) => {
              setSelectedPost(item);
              setMode('detail');
            }}
          />
        )}

        {mode === 'write' && <BoardWrite type="sample" onCancel={() => setMode('list')} onSubmit={handleSubmit} />}

        {mode === 'detail' && selectedPost && (
          <BoardDetail
            post={selectedPost}
            allPosts={[]}
            onBack={() => {
              setSelectedPost(null);
              setMode('list');
            }}
            onChangePost={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default SampleRequest;
